// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9a-3";
export var contentContainer = "_9a-0";
export var editorContainer = "_9a-1";
export var quillInputForm = "_9a-2";
export var zoneDivider = "_9a-4";